import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { axoVersionsKeys } from '../../cache-keys/axoVersionsKeys';

export function useCreateAxoVersion() {
  const queryClient = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: ace_api.createAxoVersion(api),
    onSettled: (_, __, { LoanApplicationID }) => {
      queryClient.invalidateQueries([
        axoVersionsKeys.application(LoanApplicationID),
      ]);
    },
  });
}
